<template>
  <div>
    <span class="label label--small block mb-6 leading-loose">Color</span>
    <svg
      id="color-wheel"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 320 320"
      style="enable-background:new 0 0 320 320;"
      xml:space="preserve"
      :class="userSelectedColor.option != '' ? 'js-color-wheel-focused' : ''"
    >
      <circle id="Oval" class="st0" cx="160" cy="160" r="158" />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="160"
        y1="229"
        x2="283"
        y2="229"
        gradientTransform="matrix(1 0 0 -1 0 322)"
      >
        <stop offset="0" style="stop-color:#0090CF" />
        <stop offset="0.5042" style="stop-color:#F48C91" />
        <stop offset="1" style="stop-color:#E3E2C5" />
      </linearGradient>
      <path
        id="Multicolor"
        :class="['st1 color-slice', activeClass('Multicolor')]"
        d="M283,74.1L160,159l69.3-132C250.8,38.1,269.2,54.4,283,74.1z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Darks/Black"
        :class="['st2 color-slice', activeClass('Darks/Black')]"
        d="M310,160c0,18.4-3.3,36-9.4,52.3L160,159l0,0l148.8-18.1C309.6,147.2,310,153.5,310,160z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Brown"
        :class="['st3 color-slice', activeClass('Brown')]"
        d="M260,271.8c-17.9,16-39.7,27.8-63.8,33.8L160,159l0,0L260,271.8z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Blue"
        :class="['st4 color-slice', activeClass('Blue')]"
        d="M160,159L160,159L160,159l-36.1,146.6c-24.1-6-45.9-17.8-63.8-33.8L160,159z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Pink"
        :class="['st5 color-slice', activeClass('Pink')]"
        d="M160,159L160,159L160,159L19.4,212.3C13.3,196,10,178.4,10,160c0-6.5,0.4-12.8,1.2-19.1L160,159z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />

      <path
        id="Orange"
        :class="['st6 color-slice', activeClass('Orange')]"
        d="M160,159L160,159L160,159L37,74.1c13.8-19.7,32.2-36,53.7-47.2L160,159z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Yellow"
        :class="['st7 color-slice', activeClass('Yellow')]"
        d="M160,10v149l0,0L90.7,27C111.4,16.1,135,10,160,10z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <linearGradient
        id="SVGID_2_"
        xmlns="http://www.w3.org/2000/svg"
        gradientUnits="userSpaceOnUse"
        x1="160"
        y1="116.55"
        x2="308.8"
        y2="116.55"
        class
      >
        <stop offset="0" style="stop-color:#E5E2DF" />
        <stop offset="0.1417" style="stop-color:#D7D3D1" />
        <stop offset="0.3305" style="stop-color:#BDB9B7" />
        <stop offset="0.66" style="stop-color:#E0E1E2" />
        <stop offset="0.7581" style="stop-color:#D3D3D3" />
        <stop offset="0.9456" style="stop-color:#B2AFAC" />
        <stop offset="1" style="stop-color:#A7A3A0" />
      </linearGradient>
      <path
        id="Metallic"
        :class="['st8 color-slice', activeClass('Metallic')]"
        d="M308.8,140.9L160,159l0,0l0,0l123-84.9C296.6,93.5,305.7,116.3,308.8,140.9z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Neutral/Gray"
        :class="['st9 color-slice', activeClass('Neutral/Gray')]"
        d="M300.6,212.3c-8.6,23-22.7,43.4-40.7,59.5L160,159l0,0l0,0l0,0l0,0L300.6,212.3z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Green"
        :class="['st10 color-slice', activeClass('Green')]"
        d="M196.1,305.6c-11.6,2.9-23.7,4.4-36.1,4.4s-24.6-1.5-36.1-4.4L160,159l0,0l0,0L196.1,305.6z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Purple"
        :class="['st11 color-slice', activeClass('Purple')]"
        d="M160,159L160,159L160,159L60,271.8c-18-16.1-32.1-36.5-40.7-59.5L160,159L160,159L160,159L160,159z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="White"
        :class="['st12 color-slice', activeClass('White')]"
        d="M229.3,26.9L160,159l0,0l0,0V10C185,10,208.6,16.1,229.3,26.9z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <path
        id="Red"
        :class="['st13 color-slice', activeClass('Red')]"
        d="M160,159L160,159L160,159L11.2,141c3.1-24.7,12.2-47.4,25.8-66.8L160,159L160,159L160,159L160,159z"
        @click="onSelect"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      />
      <g>
        <ellipse
          transform="matrix(0.9709 -0.2393 0.2393 0.9709 -4.3382 31.8267)"
          :class="['st12 color-slice__dot', showDot('Yellow')]"
          cx="128.9"
          cy="33.8"
          rx="8"
          ry="8"
        />
        <ellipse
          id="Orange-dot"
          transform="matrix(0.7485 -0.6631 0.6631 0.7485 -23.0151 64.7013)"
          :class="['st12 color-slice__dot', showDot('Orange')]"
          cx="73.8"
          cy="62.7"
          rx="8"
          ry="8"
        />
        <ellipse
          id="Red-dot"
          transform="matrix(0.3546 -0.935 0.935 0.3546 -81.6796 109.4545)"
          :class="['st12 color-slice__dot', showDot('Red')]"
          cx="38.4"
          cy="113.9"
          rx="8"
          ry="8"
        />
        <ellipse
          transform="matrix(0.9927 -0.1205 0.1205 0.9927 -20.934 5.0068)"
          :class="['st12 color-slice__dot', showDot('Pink')]"
          cx="30.9"
          cy="175.7"
          rx="8"
          ry="8"
        />
        <ellipse
          id="Purple-dot"
          transform="matrix(0.8231 -0.568 0.568 0.8231 -123.4317 71.4806)"
          :class="['st12 color-slice__dot', showDot('Purple')]"
          cx="53"
          cy="233.8"
          rx="8"
          ry="8"
        />
        <ellipse
          id="Blue-dot"
          transform="matrix(0.4649 -0.8854 0.8854 0.4649 -190.286 235.3703)"
          :class="['st12 color-slice__dot', showDot('Blue')]"
          cx="99.6"
          cy="275.1"
          rx="8"
          ry="8"
        />
        <circle
          id="Green-dot"
          :class="['st12 color-slice__dot', showDot('Green')]"
          cx="160"
          cy="290"
          r="8"
        />
        <ellipse
          id="Brown-dot"
          transform="matrix(0.8856 -0.4645 0.4645 0.8856 -102.5784 133.8543)"
          :class="['st12 color-slice__dot', showDot('Brown')]"
          cx="220.4"
          cy="275.1"
          rx="8"
          ry="8"
        />
        <ellipse
          transform="matrix(0.5683 -0.8228 0.8228 0.5683 -77.1903 320.633)"
          :class="['st12 color-slice__dot', showDot('Neutral/Gray')]"
          cx="267"
          cy="233.9"
          rx="8"
          ry="8"
        />
        <ellipse
          transform="matrix(0.1209 -0.9927 0.9927 0.1209 79.6905 441.4039)"
          :class="['st12 color-slice__dot', showDot('Darks/Black')]"
          cx="289"
          cy="175.7"
          rx="8"
          ry="8"
        />
        <ellipse
          transform="matrix(0.9351 -0.3543 0.3543 0.9351 -22.1058 107.1402)"
          :class="['st14 color-slice__dot', showDot('Metallic')]"
          cx="281.6"
          cy="113.9"
          rx="8"
          ry="8"
        />
        <ellipse
          id="Multicolor-dot"
          transform="matrix(0.6634 -0.7482 0.7482 0.6634 35.9441 205.3642)"
          :class="['st12 color-slice__dot', showDot('Multicolor')]"
          cx="246.2"
          cy="62.7"
          rx="8"
          ry="8"
        />
        <ellipse
          id="White-dot"
          transform="matrix(0.2397 -0.9708 0.9708 0.2397 112.5296 211.2817)"
          :class="['st14 color-slice__dot', showDot('White')]"
          cx="191.2"
          cy="33.8"
          rx="8"
          ry="8"
        />
      </g>
      <text x="50%" y="50%" class="wheel-text" text-anchor="middle">
        {{ userSelectedColor.option }}
      </text>
    </svg>
  </div>
</template>
<script>
import find from 'lodash.find';
import { eventBus, CLEAR_FILTERS } from '../../../shared/event-bus';

export default {
  props: ['options', 'selectedColor'],
  data() {
    return {
      userSelectedColor: {
        ...this.selectedColor,
      },
      userHoveredColor: {
        field_id: '',
        option_id: '',
        option: '',
      },
    };
  },
  watch: {
    selectedColor(newVal, oldVal) {
      if (newVal.option !== oldVal.option) {
        this.userSelectedColor = { ...newVal };
      }
    },
  },
  created() {
    eventBus.$on(CLEAR_FILTERS, () => {
      this.userSelectedColor = {
        field_id: '',
        option_id: '',
        option: '',
      };
    });
  },
  methods: {
    showDot(targetId) {
      return targetId == this.userSelectedColor.option ||
        targetId == this.userHoveredColor.option
        ? 'is-visible'
        : '';
    },
    activeClass(option) {
      return this.userSelectedColor.option == option ? 'is-selected' : '';
    },
    onMouseEnter(evt) {
      const targetId = evt.target.getAttribute('id');
      if (targetId) {
        const valInOptions = find(this.options, val => val.option == targetId);
        if (valInOptions) {
          this.userHoveredColor = {
            ...valInOptions,
          };
        }
      }
    },
    onMouseLeave() {
      this.userHoveredColor = {
        field_id: '',
        option_id: '',
        option: '',
      };
    },
    onSelect(evt) {
      const { target } = evt;
      const targetId = target.getAttribute('id');
      const targDomNode = document.getElementById(targetId);

      if (this.userSelectedColor.option == targetId) {
        this.userSelectedColor = {
          field_id: '',
          option_id: '',
          option: '',
        };
        this.userHoveredColor = {
          field_id: '',
          option_id: '',
          option: '',
        };
      } else {
        const valObj = find(this.options, val => val.option == targetId);
        if (valObj) {
          this.userSelectedColor = {
            ...valObj,
          };
        }
      }

      this.$emit('select', this.userSelectedColor);
    },
  },
};
</script>

<style type="text/css" scoped>
.st0 {
  fill: none;
  stroke: #dddddd;
  stroke-width: 2;
}
.st1 {
  fill: url(#SVGID_1_);
}
.st2 {
  fill: #28282e;
}
.st3 {
  fill: #9a6c48;
}
.st4 {
  fill: #1a6fb6;
}
.st5 {
  fill: #f592be;
}
.st6 {
  fill: #f1733d;
}
.st7 {
  fill: #f2d14b;
}
.st8 {
  fill: url(#SVGID_2_);
}
.st9 {
  fill: #999999;
}
.st10 {
  fill: #41af39;
}
.st11 {
  fill: #871988;
}
.st12 {
  fill: #ffffff;
}
.st13 {
  fill: #e62d37;
}
.st14 {
  fill: #231f20;
}
</style>
